<template>
    <div>
        <div class="container mt-4 mb-4">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'federal'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2">Lineamientos</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!-- AREA DE ARCHIVOS -->
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/parametros-PDP.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos que Establecen los Parámetros, Modalidades y Procedimientos para la Portabilidad de Datos Personales </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/Ramo33.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos generales de operación para la entrega de los recursos del Ramo General 33 Aportaciones Federales para Entidades Federativas y Municipios. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/Ejercicio.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para informar sobre el ejercicio, destino y resultados de los recursos federales transferidos a las entidades federativas. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/Transparencia.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para la Solicitud, Transparencia y Aplicación de los Recursos Correspondientes al Ejercicio Fiscal de 2007 con cargo al Fideicomiso para la Infraestrutura en los Estados. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/Requerimientos.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5>  Lineamientos para la determinación de los Requerimientos de Información que deberá contener el mecanismo de planeación de programas y proyectos de inversión </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/Dictamenes.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos Relativos a los dictámenes de los programas y proyectos de inversión a cargo de las dependencias y entidades de la Administración Pública Federal </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/Cartera_PPI.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para el registro en la cartera de programas y proyectos de inversión </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/Rentabilidad_PPI.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para el seguimiento de la rentabilidad de los programas y proyectos de inversión de la Administración Pública Federal </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/Costo-Beneficio-PPI.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para la elaboración y presentación de los análisis costo y beneficio de los programas y proyectos de inversión </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/Cargo-FIES.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para la Solicitud, Transferencia y Aplicación de los Recursos Correspondientes con cargo al Fideicomiso para la Infrastructura en los Estados </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!-- IMPORTANTE RECORDAR QUE LA LIGA MANDA ORIGINALMENTE A OTRA PAGINA (http://www.haciendachiapas.gob.mx/marco-juridico/Federal/Lin-transp.asp) Y ESA PAGINA SI SE DIRIGE AL ARCHIVO -->
                    <a href="https://www.dof.gob.mx/2025/SABG/LineamientosTecnicosGenerales_LTGOT.pdf" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <!--<h5> Lineamientos técnicos generales para la publicación, homologación y estandarización de la información de las obligaciones establecidas en el título quinto y en la fracción IV del artículo 31 de la Ley General de Transparencia y Acceso a la información Pública. </h5>-->
                                    <h5> Lineamientos Técnicos Generales para la Publicación, Homologación y Estandarización de la Información de las Obligaciones de Transparencia. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/elab-ejec-evaluac-PNTAI.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para la elaboración, ejecución y evaluación del Programa Nacional de Transparencia y Acceso a la Información </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/implem-operacion-PNT.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para la implementación y operación de la PNT </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/SNT-AIP-y-PDP.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos que deberán observar los SO para la atención de requerimientos, observaciones, recomendaciones y criterios que emita el SNT, AIP y PDP </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/org-conservac-archivos.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para la Organización y Conservación de los Archivos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/clasif-desaclasif-informacion.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos generales en materia de clasificación y desclasificación de la información, así como para la elaboración de versiones públicas </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Lineamientos/cat-y-pub-inf-interes-pub.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Lineamientos para determinar los catálogos y publicación de información de interés público; y para la emisión y evaluación de políticas de transparencia proactiva </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>



                </div>

                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes img_fija">
                        <div class="sec_imagen">
                            <img src="@/assets/imagenes/lineamientos.jpg" alt="">
                        </div>
                    </div>


                </div>
            </div>
            <div class="text-aviso my-5">
                <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
            </div>
        </div>
    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        atrasComponent,
        botonAtras
    }
}
</script>

<style scoped>
    .title_document {
        padding: .8rem 1rem;
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    }

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .title_document h5{
        font-size: 0.8rem;
        font-weight: 400;
        /* line-height: 20px; */
        text-align: justify;
    }

    .sec_imagen{
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    .text-aviso h5 {

        font-size: 1rem;
        font-weight: 400;
        /* line-height: 20px; */
    }
    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .resaltado-vino{
        color: #560F2C;
        font-weight: 500;
    }
    /* imagen fija */
    .img_fija{
        position: sticky !important;
        top: 7% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }
}

</style>
